import { t } from 'i18next';
import type {
  TenantMemberTextStatus,
  TotalSubscriptionUserListDTO,
} from '../subscriptionUser.types';

export class TotalSubscriptionUserListModel {
  private readonly _dto: TotalSubscriptionUserListDTO;

  constructor(dto: TotalSubscriptionUserListDTO) {
    this._dto = dto;
  }

  get isAbnormal(): string {
    return this._dto.isAbnormal === true ? 'Y' : 'N';
  }

  get softwareIconUrl(): string | undefined {
    return this._dto?.softwareIconUrl;
  }

  get softwareId(): string {
    return this._dto.softwareId ?? '';
  }

  get softwareName(): string {
    return this._dto.softwareName ?? '';
  }

  get subscriptionId(): string {
    return this._dto.subscriptionId ?? '';
  }

  get subscriptionName(): string {
    return this._dto.subscriptionName ?? '';
  }

  get tenantMemberStatus(): string {
    return this._dto.tenantMemberStatus
      ? this._dto.tenantMemberStatus === 'ACTIVE'
        ? t('Subscription.memberStatus.NORMAL_MEMBER')
        : t('Subscription.memberStatus.WITHDRAW_MEMBER')
      : t('Subscription.memberStatus.NON_MEMBER_USER');
  }

  get userEmail(): string {
    return this._dto.userEmail ?? '';
  }

  get userLoginId(): string {
    return this._dto.userLoginId ?? '';
  }

  get userName(): string {
    return this._dto.userName ?? '';
  }

  static getTenantMemberStatus(status: TenantMemberTextStatus): string {
    const statusTextMap: Record<string, string> = {
      [t('Subscription.memberStatus.NORMAL_MEMBER')]: 'ACTIVE',
      [t('Subscription.memberStatus.WITHDRAW_MEMBER')]: 'BLOCKED',
      [t('Subscription.memberStatus.NON_MEMBER_USER')]: 'NON_MEMBER',
    };
    return statusTextMap[status] ?? '';
  }

  static getTenantMemberTextStatus(status: string): string {
    const statusTextMap: Record<string, string> = {
      ACTIVE: t('Subscription.memberStatus.NORMAL_MEMBER'),
      BLOCKED: t('Subscription.memberStatus.WITHDRAW_MEMBER'),
      NON_MEMBER: t('Subscription.memberStatus.NON_MEMBER_USER'),
    };
    return statusTextMap[status] ?? '';
  }
}
